import Button, { ButtonLevel } from "components/ui/Button";
import UILabel from "components/ui/UILabel";
import React, { useState } from "react";
import styled, { css } from "styled-components";
import Layout from "../Layout";
import Calendar from "./Calendar";
import { SlideProps } from "./types";

const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin: 0 auto;
`;

const Label = styled.div<{ $isEwa?: boolean }>`
  padding: 4px 8px;

  border-radius: 2px;

  ${(props) =>
    props.$isEwa
      ? css`
          background: ${props.theme.colors.secondary};
          color: ${props.theme.colors.primary};
        `
      : css`
          background: ${props.theme.colors.disabled}44;
        `}
`;

const SLIDES = [
  {
    body: "Traditionally, you have to wait for payday to access earnings—typically only once every two weeks.",
  },
  {
    body: "With Earned Wage Access (EWA), you can access a portion of your income daily as you earn it.",
  },
];

const HowItWorks: React.FC<SlideProps> = ({ onContinue }) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const goToNext = () => {
    if (currentSlideIndex === SLIDES.length - 1) {
      return onContinue();
    }

    return setCurrentSlideIndex((s) => s + 1);
  };

  const currentSlide = SLIDES[currentSlideIndex];
  const isEwa = currentSlideIndex === 1;

  return (
    <Layout
      heading="How it works"
      subheading={currentSlide.body}
      actions={
        <Button level={ButtonLevel.cta} fullWidth onClick={goToNext}>
          Continue
        </Button>
      }
    >
      <CalendarWrapper>
        <Label $isEwa={isEwa}>
          <UILabel.Micro wideCaps bold>
            {isEwa ? "Earned Wage Access" : "Traditional Payroll"}
          </UILabel.Micro>
        </Label>

        <Calendar isEwa={isEwa} />
      </CalendarWrapper>
    </Layout>
  );
};

export default HowItWorks;
